<script setup>
import { apolloClient } from "@/utils/apolloClient";
import { provideApolloClient } from "@vue/apollo-composable";
import useNavigationLinks from "../hooks/useNavigationLinks";
import {APP} from "@/config/app";

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: "SELF_SELECT"
  },
  clientInfo: {
    type: Object,
    required: false,
  },
  hasSelfSelectPortfolio: {
    type: Boolean,
    required: true,
    default: false
  },
  corporateClientServices: {
    type: Object,
    required: true
  },
  killSwitchFlags: {
    type: Object,
    required: true
  }
});

provideApolloClient(apolloClient);

const authenticatedLinks = useNavigationLinks(props);
</script>

<template>
  <div
    v-if="!props.killSwitchFlags.getAppDisabled"
    :class="[
      'sm:hidden md:hidden lg:block py-3',
      APP.MyWealthMode
        ? 'bg-forest dark:bg-forest lg:py-8 md:py-3 font-madera-regular'
        : 'bg-mwi-rebrand-green dark:bg-mwi-rebrand-green-alt lg:py-8 md:py-3 font-madera-regular'
    ]"
  >
    <div class="max-w-7xl flex mx-auto items-center justify-start px-8 xl:px-0 text-white">
      <div class="items-center flex flex-col sm:flex-row sm:gap-x-12">
        <RouterLink
          v-for="item in authenticatedLinks"
          :key="item.name"
          :to="item.href"
          class="sub-nav-link text-white transition-all duration-300 ease-in-out text-base"
          :active-class="APP.MyWealthMode ? '' : ''"
        >
          <span v-html="item.html ?? undefined"></span>
          {{ item?.html == null ? item.name : '' }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<style>

</style>
